import styled from "styled-components";

export const Container = styled.button`
  display: flex;
`;
